// src/features/admin/adminService.js
import axios from 'axios';

const API_URL = 'https://taskprioritiser.com/api/users';

// Get all users
const getUsers = async (token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    try {
        const response = await axios.get(`${API_URL}/users`, config);

        console.log('=== ADMIN SERVICE DEBUG ===');
        console.log('Raw API response:', response);
        console.log('Response data:', response.data);
        console.log('Response data type:', typeof response.data);
        console.log('Is response.data an array?', Array.isArray(response.data));

        if (Array.isArray(response.data) && response.data.length > 0) {
            console.log('First user from API:', response.data[0]);
            console.log('First user role from API:', response.data[0].role);
        }
        console.log('=== END ADMIN SERVICE DEBUG ===');

        return response.data;
    } catch (error) {
        console.error('Error in getUsers:', error);
        throw error;
    }
};

// Update user role
const updateUserRole = async (userId, role, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    const response = await axios.put(
        `${API_URL}/users/${userId}/role`,
        { role },
        config
    );

    return response.data;
};

// Toggle user status (activate/deactivate)
const toggleUserStatus = async (userId, isActive, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    const response = await axios.put(
        `${API_URL}/users/${userId}/activate`,
        { is_active: isActive },
        config
    );

    return response.data;
};

// Delete user
const deleteUser = async (userId, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    await axios.delete(`${API_URL}/users/${userId}`, config);
    return userId;
};

// Get system settings
const getSystemSettings = async (token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    const response = await axios.get(`${API_URL}/settings`, config);
    return response.data;
};

// Update system settings
const updateSystemSettings = async (settingsData, token) => {
    const config = {
        headers: {
            Authorization: `Bearer ${token}`
        }
    };

    const response = await axios.put(
        `${API_URL}/settings`,
        settingsData,
        config
    );

    return response.data;
};

const adminService = {
    getUsers,
    updateUserRole,
    toggleUserStatus,
    deleteUser,
    getSystemSettings,
    updateSystemSettings
};

export default adminService;
